module.exports = __webpack_public_path__ + "img/upload.4cea6672.png";